import { useThree } from '@react-three/fiber'
import { useEffect } from 'react'
import type { PerspectiveCamera } from 'three'

/** Lente da mesa: mais fechada que a do estúdio, para a maquete não distorcer. */
const FOV_MESA = 32
/** De três quartos e do alto, como quem olha uma maquete sobre a mesa. */
const POSICAO_MESA: [number, number, number] = [13, 14, 16]

/**
 * Ao entrar no Table top, a câmera vai para a vista de maquete; ao sair, a
 * lente volta a ser a do estúdio. A posição seguinte é de quem vier depois:
 * as outras cenas enquadram o veículo por conta própria.
 */
export function CameraDaMesa() {
  const camera = useThree((estado) => estado.camera) as PerspectiveCamera
  const controles = useThree((estado) => estado.controls) as { target?: { set: (x: number, y: number, z: number) => void }; update?: () => void } | null
  useEffect(() => {
    if (!('fov' in camera)) return
    const fovAnterior = camera.fov
    camera.fov = FOV_MESA
    camera.position.set(...POSICAO_MESA)
    camera.updateProjectionMatrix()
    controles?.target?.set(0, 0, 0)
    controles?.update?.()
    return () => {
      camera.fov = fovAnterior
      camera.updateProjectionMatrix()
    }
  }, [camera, controles])
  return null
}
